import React from 'react';
import {connect} from 'react-redux';
import {Container, Header, Grid, Loader, Sticky} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Alert} from 'componentLibrary';
import OrganizationDropdown from 'go/components/organization/OrganizationDropdown';
import AddSubOrganizationContainer from 'go/components/organization/subOrganization/addSubOrganization';
import OrganizationSummaryCard from './OrganizationSummaryCard';
import OrganizationSearch from './OrganizationSearch';
import {isAOR, isEntityRoleAvailable, isOrgProgramAOR} from 'go/security/permissions';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import {API_ORG_PROGRAM_GET_SUCCESS, SET_ORG_ID, SET_DEFAULT_ORG_ID} from 'common/types';
import ApiActions from 'go/actions/api';
import REST from 'go/requests/rest';
import PermissionsUtility from 'go/security/permissionsUtility';
import {SUBORG_MY_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {fetchMoreOrgData} from 'common/utils';

const LOCAL_STORAGE_KEY = 'organizationRadioSelection';
const FILTER_KEYS = ['radioSelection', 'dunsText', 'einText', 'nameText', 'addressText'];

export class OrganizationListAndSearchContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      offset: 1,
      limit: 25,
      organizationId: '',
      programIds: [],
      responseBody: {},
      results: [],
      defaultValue: '',
      searchRadio: 'duns',
      value: 'duns',
      searchName: '',
      searchDUNS: '',
      searchUEI: '',
      searchEIN: '',
      searchAddress: '',
      filterSelection: '',
      sortSelection: 'legalBusinessName',
      sortRadio: 'asc',
      orgDisplayName: '',
      orgError: false,
    };
  }

  componentDidMount() {
    document.title = SUBORG_MY_PAGE;
  }

  UNSAFE_componentWillMount() {
    const {token, getAllOrganizationProgramsUnrestricted, orgId} = this.props;
    const organizationId = orgId ? orgId : this.props.match.params.orgId;
    if (organizationId) {
      this.setState({
        defaultValue: organizationId,
        organizationId: organizationId,
      });
    }

    getAllOrganizationProgramsUnrestricted(token).then((res) => {
      if (res) {
        const programs = res.payload;
        let ids = new Set(
          _.map(programs, (program) => {
            return program.programId;
          })
        );
        let programIds = Array.from(ids).toString();
        this.setState({programIds}, () => {
          const item = this.getStoredFilters();
          const {
            radioSelection,
            dunsText,
            ueiText,
            einText,
            nameText,
            addressText,
          } = item;

          this.clearAllFilters();

          if (this.props.organizationId) {
            this.setState(
              {
                value: radioSelection,
                searchDUNS: dunsText,
                searchUEI: ueiText,
                searchEIN: einText,
                searchName: nameText,
                searchAddress: addressText,
              },
              () => {
                this.updateFilter(this.state);

                if (dunsText !== undefined) {
                  let orgDUNS = {duns: dunsText};
                  this.updateFilter(orgDUNS);
                }

                if (ueiText !== undefined) {
                  let orgUEI = {uei: ueiText};
                  this.updateFilter(orgUEI);
                }

                if (einText !== undefined) {
                  let orgEIN = {ein: einText};
                  this.updateFilter(orgEIN);
                }

                if (nameText !== undefined) {
                  let orgName = {name: nameText};
                  this.updateFilter(orgName);
                }

                if (addressText !== undefined) {
                  let orgAddress = {address: addressText};
                  this.updateFilter(orgAddress);
                }
              }
            );
          }
        });
      }
    });
  }

  /*
  When cleaning up programAOR toggle, this method can be removed.
  When working GMMGO-63592 prior spike ticket GMMGO-69279 analysis identified this
  as having flawed logic (comparing roleId values of EHP roles to program IDs) and
  that EHP users shouldn't be accessing this component (logged in as EHP reviewer
  and they do not have an Organizations menu option).  This is for component is
  for external users, as I understand, and EHP users are internal.
  */
  isEHPAdminReviewer = (organizationId) => {
    const permissionUtil = new PermissionsUtility(this.props.token);
    const progs = permissionUtil.getProgramForOrganization(organizationId);
    return (
      _.includes(progs, ROLE_MAP.EHPADMIN.code) ||
      _.includes(progs, ROLE_MAP.EHPREVIEWER.code)
    );
  };

  componentDidUpdate(prevProps) {
    let {location, defaultOrgId} = this.props;
    if (location && prevProps.location && location.key !== prevProps.location.key) {
      this.setState({
        defaultValue: defaultOrgId,
        organizationId: defaultOrgId,
      });
      this.handleOrgChange(defaultOrgId);
    }
  }

  handleOrgChange = (organizationId) => {
    if (organizationId) {
      this.props.setOrgId(organizationId);

      const item = this.getStoredFilters();
      const {radioSelection, dunsText, ueiText, einText, nameText, addressText} = item;
      this.setState(
        {
          organizationId,
          loading: true,
          defaultValue: organizationId,
          offset: 1,
          limit: 25,
          searchName: nameText,
          searchDUNS: dunsText,
          searchUEI: ueiText,
          searchEIN: einText,
          searchAddress: addressText,
          value: radioSelection,
          sortRadio: 'asc',
          sortSelection: 'legalBusinessName',
        },
        () => {
          this.updateFilter(this.state);

          if (dunsText) {
            let orgDUNS = {duns: dunsText};
            this.updateFilter(orgDUNS);
          }

          if (ueiText) {
            let orgUEI = {uei: ueiText};
            this.updateFilter(orgUEI);
          }

          if (einText) {
            let orgEIN = {ein: einText};
            this.updateFilter(orgEIN);
          }

          if (nameText) {
            let orgName = {name: nameText};
            this.updateFilter(orgName);
          }

          if (addressText) {
            let orgAddress = {address: addressText};
            this.updateFilter(orgAddress);
          }

          this.fetchMoreData({});
        }
      );
    }
  };

  handleOrgDropdownError = (error) => {
    this.setState({dropDownError: error});
  };

  updateFilter = (fetchInfo) => {
    const {responseBody} = this.state;
    responseBody.sortBy = fetchInfo.sortBy;
    responseBody.sortOrder = fetchInfo.sortOrder;
    this.setState(
      {
        loading: true,
        responseBody: fetchInfo,
        offset: 1,
        limit: 25,
        results: [],
      },
      () => {
        this.fetchMoreData(fetchInfo);
      }
    );
  };

  fetchMoreData = _.debounce((fetchInfo) => {
    let {organizationId, programIds, results, offset, limit} = this.state;
    const {duns, uei, name, ein, address, sortBy, sortOrder} = this.state.responseBody;
    let searchFilter = this.mapValuesToObject(
      duns,
      uei,
      name,
      ein,
      address,
      sortBy,
      sortOrder
    );
    if (organizationId) {
      REST.organization
        .getSearchForSuborganizations(
          this.props.token,
          organizationId,
          programIds,
          searchFilter,
          offset
        )
        .then(REST.handler.handleResponse)
        .then((rslts) => {
          this.setState(
            fetchMoreOrgData(rslts, fetchInfo, this.state.limit, offset, results)
          );
        })
        .catch((error) => {
          if (error) {
            this.setState({orgError: true, showSearch: true});
            console.error('error');
          }
        });
    } else {
      this.setState({orgError: true, showSearch: true});
    }
  }, 250);

  getStoredFilters = () => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
    if (filter) {
      if (filter.userId !== id) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
      } else return filter;
    }
    return {};
  };

  handleLocalStorageChange = (userEnteredChanges, storageKey) => {
    const {id} = this.props;
    const userStoredFilters = this.getStoredFilters();

    const filter = userStoredFilters;
    let value;
    if (userEnteredChanges === '') {
      _.unset(userStoredFilters, storageKey);
      value = userStoredFilters;
    } else {
      value = _.set(filter, storageKey, userEnteredChanges);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({...value, userId: id}));
  };

  handleSearchRadio = (e, {value}) => {
    this.clearAllFilters();
    this.setState({value});
    _.each(FILTER_KEYS, (key) => {
      if (key !== 'radioSelection') {
        this.handleLocalStorageChange('', key);
      } else {
        this.handleLocalStorageChange(value, 'radioSelection');
      }
    });
  };

  handleDUNSText = (e) => {
    this.setState({
      searchDUNS: e.target.value,
      searchUEI: '',
      searchName: '',
      searchEIN: '',
      searchAddress: '',
    });
    this.updateDUNS(e.target.value);
    this.handleLocalStorageChange(e.target.value, 'dunsText');
  };

  handleUEIText = (e) => {
    this.setState({
      searchUEI: e.target.value,
      searchDUNS: '',
      searchName: '',
      searchEIN: '',
      searchAddress: '',
    });
    this.updateUEI(e.target.value);
    this.handleLocalStorageChange(e.target.value, 'ueiText');
  };

  handleNameText = (e) => {
    this.setState({
      searchDUNS: '',
      searchUEI: '',
      searchName: e.target.value,
      searchEIN: '',
      searchAddress: '',
    });
    this.updateName(e.target.value);
    this.handleLocalStorageChange(e.target.value, 'nameText');
  };

  handleEINText = (e) => {
    this.setState({
      searchDUNS: '',
      searchUEI: '',
      searchName: '',
      searchEIN: e.target.value,
      searchAddress: '',
    });
    this.updateEIN(e.target.value);
    this.handleLocalStorageChange(e.target.value, 'einText');
  };

  handleAddressText = (e) => {
    this.setState({
      searchDUNS: '',
      searchName: '',
      searchEIN: '',
      searchUEI: '',
      searchAddress: e.target.value,
    });
    this.updateAddress(e.target.value);
    this.handleLocalStorageChange(e.target.value, 'addressText');
  };

  handleFilterSelection = (e) => {
    this.setState({filterSelection: e.target.value});
    this.updateFilterSelection();
  };

  handleSortSelection = (e) => {
    this.setState({sortSelection: e.target.value});
    this.updateSortSelection(e.target.value);
  };

  handleSortRadio = (e) => {
    this.setState({sortRadio: e.target.value});
    this.updateSort(e.target.value);
  };

  updateDUNS = (value) => {
    let orgDUNS = {duns: valueOrUndefined(value)};
    this.updateFilter(orgDUNS);
  };

  updateUEI = (value) => {
    let orgUEI = {uei: valueOrUndefined(value)};
    this.updateFilter(orgUEI);
  };

  updateEIN = (value) => {
    let orgEIN = {ein: valueOrUndefined(value)};
    this.updateFilter(orgEIN);
  };

  updateName = (value) => {
    let orgName = {name: valueOrUndefined(value)};
    this.updateFilter(orgName);
  };

  updateAddress = (value) => {
    let orgAddress = {address: valueOrUndefined(value)};
    this.updateFilter(orgAddress);
  };

  updateFilterSelection = (value) => {
    let orgFilterBy = {filter: valueOrUndefined(value)};
    this.updateFilter(orgFilterBy);
  };

  updateSortSelection = (value) => {
    let responseBody = {sortBy: valueOrUndefined(value), sortOrder: this.state.sortRadio};
    this.setState({
      sortSelection: value,
    });
    this.updateFilter(responseBody);
  };

  updateSort = async (value) => {
    let responseBody = {
      sortBy: this.state.sortSelection,
      sortOrder: valueOrUndefined(value),
    };
    await this.setState({
      sortRadio: value,
    });
    this.updateFilter(responseBody);
  };

  // clears search filters for local storage key (LOCAL_STORAGE_KEY = 'organizationRadioSelection')
  clearLocalStorage = () => {
    _.each(FILTER_KEYS, (key) => {
      this.handleLocalStorageChange('', key);
    });
  };

  clearAllFilters = () => {
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const getDefaultValue = dunsToUEIToggle ? 'uei' : 'duns';
    this.setState(
      {
        searchName: '',
        searchDUNS: '',
        searchUEI: '',
        searchEIN: '',
        searchAddress: '',
        value: getDefaultValue,
        sortRadio: 'asc',
        sortSelection: 'legalBusinessName',
      },
      () => {
        this.updateFilter(this.state);
      }
    );
  };

  mapValuesToObject = (duns, uei, name, ein, address, sortBy, sortOrder) => {
    return {
      duns: duns,
      uei: uei,
      name: name,
      ein: ein,
      address: address,
      sortBy: sortBy,
      sortOrder: sortOrder,
    };
  };

  formatSAM(isManuallyAdded) {
    return isManuallyAdded === 'Y' ? 'No' : 'Yes';
  }

  getCurrentOrgDisplayName = (orgId) => {
    REST.user
      .getEntities(this.props.token)
      .then(REST.handler.handleResponse)
      .then((res) => {
        res = _.difference(res, this.props.suborgsAllowed);
        let selectedObj = _.find(res, {entityId: orgId});
        if (selectedObj) {
          this.setState({orgDisplayName: selectedObj.displayName});
        }
      });
    return this.state.orgDisplayName;
  };

  setDefaultOrg = (_defaultId) => {
    this.props.setDefaultOrgId(_defaultId);
  };

  renderOrgDetails = (isUserAOR, isOrgAOR, isOrgProgAOR) => {
    const {organizationId, results, searchError} = this.state;
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    let filteredResults = _.filter(
      results,
      (result) => result.organizationId !== parseInt(organizationId, 10)
    );
    return (
      <Grid.Column width={12}>
        {filteredResults && filteredResults.length > 0 ? (
          <OrganizationSummaryCard
            orgId={organizationId}
            results={filteredResults}
            fetchMoreData={this.fetchMoreData}
            hasMore={this.state.hasMore}
            nameLabel="Suborganization name"
            addressLabel="Mailing address"
            numberLabelOne={'UEI-EFT'}
            numberLabelTwo={'DUNS#'}
            actionLabel="Action"
            isUserAOR={isUserAOR}
            isOrgAOR={isOrgAOR}
            isOrgProgAOR={isOrgProgAOR}
            registeredLabel="Registered in SAM.gov"
            formatSAM={this.formatSAM}
            dunsToUEIToggle={dunsToUEIToggle}
          />
        ) : searchError ? (
          <Alert header="No suborganizations available" type="warning">
            There were no suborganizations found that match your search criteria
          </Alert>
        ) : null}
      </Grid.Column>
    );
  };

  render() {
    const {permissions, suborgsAllowed, toggles} = this.props;
    const {
      loading,
      organizationId,
      renderType,
      defaultValue,
      showSearch,
      orgError,
    } = this.state;
    const isUserAOR = isAOR(permissions);
    const isEHPAdminReview = this.isEHPAdminReviewer(organizationId);
    const isOrgAOR = isEntityRoleAvailable(
      permissions,
      organizationId,
      ROLE_MAP.ORGAOR.code
    );
    const isOrgProgAOR = isOrgProgramAOR(
      permissions,
      organizationId,
      ROLE_MAP.ORGAOR.code
    );

    const programAorToggle = _.includes(toggles, 'programAOR');
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const sortReorder = _.includes(toggles, 'disasterSiteNav');
    const toggleRadioBtn = dunsToUEIToggle ? 'uei' : 'duns';
    const setRadioBtnValue =
      this.state.value == 'uei' && !dunsToUEIToggle
        ? 'duns'
        : this.state.value
        ? this.state.value
        : toggleRadioBtn;

    const canAddSuborg =
      !orgError &&
      suborgsAllowed &&
      isUserAOR &&
      (isOrgAOR ||
        (programAorToggle && isOrgProgAOR) ||
        (!programAorToggle && isEHPAdminReview));

    const suborgComp = canAddSuborg ? (
      <AddSubOrganizationContainer
        programId={this.state.programIds}
        organizationId={this.state.organizationId}
        fetchMoreData={this.fetchMoreData}
        getCurrentOrgDisplayName={this.getCurrentOrgDisplayName}
      />
    ) : null;
    return (
      <Main>
        {sortReorder && (
          <Container className="sub-organization" fluid>
            <Grid
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
              className="org-details-wrapper suborg-listing"
            >
              <Grid.Column width={12}>
                <OrganizationDropdown
                  type={renderType ? renderType : null}
                  handleOrgChange={(orgId) => this.handleOrgChange(orgId)}
                  handleError={(error) => this.handleOrgDropdownError(error)}
                  defaultValue={defaultValue}
                  setDefaultOrg={(_defaultOrgId) => this.setDefaultOrg(_defaultOrgId)}
                  defaultOrgNumber={this.props.defaultOrgId}
                  {...this.props}
                />
              </Grid.Column>
            </Grid>
            <Grid>
              {showSearch ? (
                <Grid.Column width={4}>
                  <OrganizationSearch
                    clearLocalStorage={this.clearLocalStorage}
                    value={setRadioBtnValue}
                    searchName={this.state.searchName}
                    searchUEI={this.state.searchUEI}
                    searchDUNS={this.state.searchDUNS}
                    searchEIN={this.state.searchEIN}
                    searchAddress={this.state.searchAddress}
                    sortSelection={this.state.sortSelection}
                    sortRadio={this.state.sortRadio}
                    handleSearchRadio={this.handleSearchRadio}
                    handleDUNSText={this.handleDUNSText}
                    handleUEIText={this.handleUEIText}
                    handleNameText={this.handleNameText}
                    handleEINText={this.handleEINText}
                    handleAddressText={this.handleAddressText}
                    handleSortSelection={this.handleSortSelection}
                    handleSortRadio={this.handleSortRadio}
                    updateFilter={this.updateFilter}
                    clearAllFilters={this.clearAllFilters}
                    dunsToUEIToggle={dunsToUEIToggle}
                  />
                </Grid.Column>
              ) : null}
              <Grid.Column width={12}>
                <Grid>
                  <Grid.Column align="left" width={8}>
                    <Header as="h2">My suborganizations</Header>
                  </Grid.Column>
                  <Grid.Column align="right" width={4}>
                    {suborgComp}
                  </Grid.Column>
                </Grid>
                {!orgError ? (
                  <>
                    <Grid.Column width={4}></Grid.Column>
                    <Grid.Column width={12}>
                      {loading ? (
                        <Loader inline="centered" active>
                          Loading...
                        </Loader>
                      ) : (
                        this.renderOrgDetails(isUserAOR, isOrgAOR, isOrgProgAOR)
                      )}
                    </Grid.Column>
                  </>
                ) : (
                  <>
                    <Grid.Column width={4}></Grid.Column>
                    <Grid.Column width={12}>
                      <Alert header="No suborganizations available" type="warning">
                        Currently there are no suborganizations associated with your
                        organization.
                      </Alert>
                    </Grid.Column>
                  </>
                )}
              </Grid.Column>
            </Grid>
          </Container>
        )}
        {!sortReorder && (
          <Container className="sub-organization" fluid>
            <Grid
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
              className="org-details-wrapper suborg-listing"
            >
              <Grid.Column width={12}>
                <OrganizationDropdown
                  type={renderType ? renderType : null}
                  handleOrgChange={(orgId) => this.handleOrgChange(orgId)}
                  handleError={(error) => this.handleOrgDropdownError(error)}
                  defaultValue={defaultValue}
                  setDefaultOrg={(_defaultOrgId) => this.setDefaultOrg(_defaultOrgId)}
                  defaultOrgNumber={this.props.defaultOrgId}
                  {...this.props}
                />
              </Grid.Column>
              {showSearch ? (
                <Grid.Column width={4}>
                  <Sticky>
                    <OrganizationSearch
                      clearLocalStorage={this.clearLocalStorage}
                      value={setRadioBtnValue}
                      searchName={this.state.searchName}
                      searchUEI={this.state.searchUEI}
                      searchDUNS={this.state.searchDUNS}
                      searchEIN={this.state.searchEIN}
                      searchAddress={this.state.searchAddress}
                      sortSelection={this.state.sortSelection}
                      sortRadio={this.state.sortRadio}
                      handleSearchRadio={this.handleSearchRadio}
                      handleDUNSText={this.handleDUNSText}
                      handleUEIText={this.handleUEIText}
                      handleNameText={this.handleNameText}
                      handleEINText={this.handleEINText}
                      handleAddressText={this.handleAddressText}
                      handleSortSelection={this.handleSortSelection}
                      handleSortRadio={this.handleSortRadio}
                      updateFilter={this.updateFilter}
                      clearAllFilters={this.clearAllFilters}
                      dunsToUEIToggle={dunsToUEIToggle}
                    />
                  </Sticky>
                </Grid.Column>
              ) : null}
            </Grid>
            <Grid>
              <Grid.Column align="left" width={8}>
                <Header as="h2">My suborganizations</Header>
              </Grid.Column>
              <Grid.Column align="right" width={4}>
                {suborgComp}
              </Grid.Column>
            </Grid>
            {!orgError ? (
              <Grid>
                <Grid.Column width={12}>
                  {loading ? (
                    <Loader inline="centered" active>
                      Loading...
                    </Loader>
                  ) : (
                    this.renderOrgDetails(isUserAOR, isOrgAOR, isOrgProgAOR)
                  )}
                </Grid.Column>
              </Grid>
            ) : (
              <Grid>
                <Grid.Column width={12}>
                  <Alert header="No suborganizations available" type="warning">
                    Currently there are no suborganizations associated with your
                    organization.
                  </Alert>
                </Grid.Column>
              </Grid>
            )}
          </Container>
        )}
      </Main>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    orgId: state.userSessionData.orgId,
    defaultOrgId: state.userSessionData.defaultOrgId,
    suborgsAllowed: state.userSessionData.suborgsAllowed,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getAllOrganizationProgramsUnrestricted: (token) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsUnrestricted(
      token
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  setOrgId: (id) => {
    dispatch({type: SET_ORG_ID, payload: id});
  },
  setDefaultOrgId: (defaultId) => {
    dispatch({type: SET_DEFAULT_ORG_ID, payload: defaultId});
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationListAndSearchContainer);

function valueOrUndefined(value) {
  return _.isEmpty(value) ? undefined : value;
}
